import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { FormattedMessage as T, useIntl } from "react-intl";
import EmailTemplateForm from "./EmailTemplateForm";

export default function EmailTemplateCreateForm() {
  const { formatMessage: t } = useIntl();
  const { emailTemplatesUrl } = useGlobalContext();

  useTitle(t({ id: "createEmailTemplate" }));

  return (
    <>
      <RedirectBackButton
        redirectRoute={emailTemplatesUrl()}
        labelKey="backToListButtonLabel"
      />
      <h2>
        <T id="addEmailTemplate" />
      </h2>
      <EmailTemplateForm submitLabel={t({ id: "createEmailTemplate" })} />
    </>
  );
}
